import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { getCurrentEmployee, logoutWithPIN } from '../../services/pinAuthService';
import styles from './AdminLayout.module.css';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const employee = getCurrentEmployee();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    logoutWithPIN();
    setMobileMenuOpen(false);
    navigate('/admin/login');
  };

  const menuItems = [
    { path: '/admin', label: 'DASHBOARD' },
    { path: '/register', label: 'REGISTER' },
  ];

  const handleNavClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <div className={styles.adminLayout}>
      {/* Mobile header */}
      <div className={styles.mobileHeader}>
        <div className={styles.mobileLogo}>
          <h1>REFUGE</h1>
          <p className={styles.mobileRole}>ADMIN</p>
        </div>
        <button
          className={styles.hamburger}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`${styles.hamburgerLine} ${mobileMenuOpen ? styles.open : ''}`}></span>
          <span className={`${styles.hamburgerLine} ${mobileMenuOpen ? styles.open : ''}`}></span>
          <span className={`${styles.hamburgerLine} ${mobileMenuOpen ? styles.open : ''}`}></span>
        </button>
      </div>

      {/* Mobile overlay */}
      {mobileMenuOpen && (
        <div className={styles.overlay} onClick={() => setMobileMenuOpen(false)}></div>
      )}

      {/* Sidebar */}
      <div className={`${styles.sidebar} ${mobileMenuOpen ? styles.open : ''}`}>
        <div className={styles.logo}>
          <h1>REFUGE</h1>
          <p className={styles.role}>ADMIN PORTAL</p>
        </div>

        <nav className={styles.nav}>
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/admin'}
              className={({ isActive }) =>
                `${styles.navItem} ${isActive ? styles.active : ''}`
              }
              onClick={handleNavClick}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className={styles.userSection}>
          {employee && (
            <>
              <div className={styles.userAvatar}>
                {employee.name.charAt(0).toUpperCase()}
              </div>
              <div className={styles.userInfo}>
                <div className={styles.userName}>{employee.name}</div>
                <div className={styles.userRole}>Admin</div>
              </div>
            </>
          )}
          <button onClick={handleLogout} className={styles.logoutButton}>
            LOG OUT
          </button>
        </div>
      </div>

      {/* Main content */}
      <div className={styles.mainContent}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
};
